import { PlusIcon, LinkIcon, ShareIcon } from "@heroicons/react/20/solid";

const QuickActions = ({ onCreateAppointment, onShareBookingLink }) => {
  return (
    <>
      {/* Desktop: labelled buttons */}
      <div className="hidden sm:flex items-center gap-2">
        {onShareBookingLink && (
          <button
            onClick={onShareBookingLink}
            className="inline-flex items-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-ink-900 ring-1 ring-inset ring-ink-200 hover:bg-cream-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink-200"
          >
            <LinkIcon className="size-4 -ml-0.5" />
            Share Booking Link
          </button>
        )}
        <button
          onClick={onCreateAppointment}
          className="inline-flex items-center gap-x-1.5 rounded-md bg-accent-500 px-3 py-2 text-sm font-semibold text-white hover:bg-accent-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-500"
        >
          <PlusIcon className="size-4 -ml-0.5" />
          New Appointment
        </button>
      </div>

      {/* Mobile: icon-only Share button. Create-appointment is owned by BottomNav's center +New. */}
      {onShareBookingLink && (
        <button
          onClick={onShareBookingLink}
          aria-label="Share"
          className="sm:hidden inline-flex items-center justify-center rounded-md bg-white p-2 text-ink-700 ring-1 ring-inset ring-ink-200 hover:bg-cream-100"
        >
          <ShareIcon className="size-5" />
        </button>
      )}
    </>
  );
};

export default QuickActions;
